(function () {
  'use strict';

  var CART_KEYS = ['valcairn_project_cart_v1', 'valcairn_project_cart', 'valcairn_project_items'];

  function safeJSON(value) {
    try { return JSON.parse(value || '[]'); } catch (error) { return []; }
  }

  function readProjectItems() {
    if (!window.localStorage) return [];

    for (var i = 0; i < CART_KEYS.length; i += 1) {
      var data = safeJSON(window.localStorage.getItem(CART_KEYS[i]));
      if (Array.isArray(data) && data.length) return data;
    }

    return [];
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[char];
    });
  }

  function renderAccountProjectDrafts() {
    var mounts = document.querySelectorAll('[data-vca-project-drafts]');
    if (!mounts.length) return;

    var items = readProjectItems();

    mounts.forEach(function (mount) {
      var inquiryUrl = mount.getAttribute('data-inquiry-url') || '/pages/request-a-quote';

      if (!items.length) {
        mount.innerHTML = '' +
          '<div class="vca-empty-card">' +
            '<p class="vca-empty-card__eyebrow">No draft inquiry on this device</p>' +
            '<p>Your saved project items will appear here before submission. Submitted inquiries and formal payment links require the project backend phase.</p>' +
            '<a class="vca-text-link" href="' + escapeHTML(inquiryUrl) + '">Start a design inquiry</a>' +
          '</div>';
        return;
      }

      var list = items.map(function (item) {
        var title = item.title || item.productTitle || item.name || 'Project item';
        var stone = item.selectedStoneTitle || item.material || item.selectedMaterial || '';
        var img = item.selectedProductImage || item.image || item.productImage || item.selectedStoneImage || '';
        return '' +
          '<article class="vca-project-draft-item">' +
            (img ? '<div class="vca-project-draft-item__media"><img src="' + escapeHTML(img) + '" alt="' + escapeHTML(title) + '" loading="lazy"></div>' : '<div class="vca-project-draft-item__media vca-project-draft-item__media--empty"></div>') +
            '<div class="vca-project-draft-item__body">' +
              '<p class="vca-project-draft-item__title">' + escapeHTML(title) + '</p>' +
              (stone ? '<p class="vca-project-draft-item__meta">' + escapeHTML(stone) + '</p>' : '') +
            '</div>' +
          '</article>';
      }).join('');

      mount.innerHTML = '' +
        '<div class="vca-project-drafts-head">' +
          '<div>' +
            '<p class="vca-kicker">Draft inquiry</p>' +
            '<h3>' + items.length + ' item' + (items.length === 1 ? '' : 's') + ' saved for review</h3>' +
            '<p>These items are saved in this browser. Submit the inquiry to create a formal project record.</p>' +
          '</div>' +
          '<a class="vca-button vca-button--dark" href="' + escapeHTML(inquiryUrl) + '">Review inquiry</a>' +
        '</div>' +
        '<div class="vca-project-draft-list">' + list + '</div>';
    });
  }

  document.addEventListener('DOMContentLoaded', renderAccountProjectDrafts);
  window.addEventListener('storage', renderAccountProjectDrafts);
  window.addEventListener('valcairn:project-cart-updated', renderAccountProjectDrafts);
})();
